






















import {Component, PropSync} from 'vue-property-decorator';
import {Action, Getter} from "vuex-class";
import BaseFilter from "@/components/Filter/BaseFilter";
import {AddressBookFilter} from "@/store/addressbooks/types";
import {FilterWings, SelectWings, FilterSelectedItemWings, InputWings} from "wings-ui-components";
import {notifyError} from "@/utils/notify-helper";
import { getTranslatedParams } from '@/utils/notify-utils';

@Component({components: {FilterSelectedItemWings, SelectWings, FilterWings, InputWings}})
export default class AddressBooksFilter extends BaseFilter<AddressBookFilter> {
  @PropSync('show') is_show!: boolean;
  @Action("getAddressBooks") actionGetAddressBooks: any;
  @Action("actionLog") actionLog: any;

  log: boolean = false

  defaultFilter(): AddressBookFilter {
    return {
      name: undefined,
    };
  }

  created() {
    this.filtered();
  }

  async onFilteredAction() {
    try {
      this.logObject = {
        actionPage: this.$route.meta.msgKey,
        action: "Viewing",
        actionStatus: 'success',
        objectType: "Address book",
        addititionalInfo: getTranslatedParams(this.filter)
      }
      await this.actionGetAddressBooks(this.filter);
      if (this.log) await this.actionLog(this.logObject)
      this.log = true
    } catch(error) {
      notifyError(error);
      await this.actionLog({...this.logObject, actionStatus: 'failed'})
    }
  }

}
